import { useState } from "react";
import { Page } from "../components/ui.jsx";
import { CALENDAR } from "../data/calendar.js";
import { LINKS } from "../data/site.js";
import { rankOf } from "../data/levels.js";
import { eventsOn, upcoming, MONTHS, MONTHS_SHORT, DOW } from "../lib/events.js";

function Month({ y, m, userRank, sel, onSel }) {
  const leading = new Date(y, m, 1).getDay();
  const days = new Date(y, m + 1, 0).getDate();

  const cells = [];
  for (let i = 0; i < leading; i++) cells.push(null);
  for (let d = 1; d <= days; d++) cells.push(d);

  const selected = sel && sel.y === y && sel.m === m ? sel.d : null;
  const selectedEvents = selected ? eventsOn(y, m, selected, userRank) : [];

  return (
    <div className="cal">
      <div className="mtitle">
        {MONTHS[m]} {y}
      </div>
      <div className="dow">
        {DOW.map((d, i) => (
          <span key={i}>{d}</span>
        ))}
      </div>
      <div className="grid">
        {cells.map((d, i) => {
          if (!d) return <div key={"b" + i} className="cell blank" />;
          const events = eventsOn(y, m, d, userRank);
          const has = events.length > 0;
          const isSel = selected === d;
          return (
            <button
              key={d}
              className={"cell" + (has ? " has" : "") + (isSel ? " sel" : "")}
              onClick={() => has && onSel(isSel ? null : { y, m, d })}
              aria-label={
                `${MONTHS[m]} ${d}` +
                (has ? `, ${events.length} event${events.length > 1 ? "s" : ""}` : "")
              }
              disabled={!has}
            >
              <span>{d}</span>
              {has && <span className="cdot" />}
            </button>
          );
        })}
      </div>

      {selected && (
        <div className="daypanel">
          <div className="dphead">
            <span className="dpt">
              {new Date(y, m, selected).toLocaleDateString(undefined, {
                weekday: "long",
                month: "long",
                day: "numeric",
              })}
            </span>
            <button className="dpclose" onClick={() => onSel(null)}>
              × close
            </button>
          </div>
          {selectedEvents.map((e, i) => (
            <div key={i} className="evrow">
              <span className="evtime">{e.time}</span>
              <span>
                <span className="evname">
                  {e.emoji} {e.name}
                </span>
                {e.tag && (
                  <>
                    <br />
                    <span className="evtag">{e.tag}</span>
                  </>
                )}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default function Calendar({ back, userRank }) {
  const [sel, setSel] = useState(null);
  const next = upcoming(userRank, 4);

  return (
    <Page
      back={back}
      eyebrow="The Rhythm"
      title="myTRiBE Calendar."
      keepCase
      intro="Everything coming up in the room — tap any dotted day to see what's happening. Some rhythms only show for the teams that carry them."
    >
      <div className="std-wrap">
        <div className="eyebrow">Save The Date</div>
        {next.map((e, i) => (
          <button
            key={i}
            className="std"
            onClick={() => setSel({ y: e.y, m: e.m, d: e.day })}
          >
            <span className="stdd">
              <div className="mo">{MONTHS_SHORT[e.m]}</div>
              <div className="da">{e.day}</div>
            </span>
            <span>
              <div className="stdn">
                {e.emoji} {e.name}
              </div>
              <div className="stdt">
                {e.time}
                {e.tag ? ` · ${e.tag}` : ""}
              </div>
            </span>
          </button>
        ))}
      </div>

      {CALENDAR.months.map(([y, m]) => (
        <Month key={`${y}-${m}`} y={y} m={m} userRank={userRank} sel={sel} onSel={setSel} />
      ))}

      <a className="card" href={LINKS.events} target="_blank" rel="noreferrer">
        <div className="name">
          <span>🗓️ Full calendar & registration on Church Center</span>
          <span className="arrow">→</span>
        </div>
      </a>

      {userRank >= rankOf("leader") && (
        <a className="card" href={LINKS.servingSchedule} target="_blank" rel="noreferrer">
          <div className="name">
            <span>📋 Your serving schedule</span>
            <span className="badge">Leader</span>
          </div>
          <div className="desc">
            Planning Center Services — sign in to see when you're scheduled.
          </div>
        </a>
      )}
    </Page>
  );
}
